import React from 'react';
import './UpskillResources.css';

const UpskillResources = () => {
    return (
        <section className="upskill-section">
            <div className="upskill-container">
                <h2 className="upskill-title">Upskill Resources</h2>
                <h3 className="upskill-tagline">Career Guidance & Growth Strategies</h3>

                <p className="upskill-description">
                    Build the skills you need to grow in the pharmaceutical industry with confidence. Our upskill resources help you understand your current level, explore career opportunities, and plan your next step clearly.
                </p>

                <div className="upskill-content-block">
                    <p className="upskill-description"><strong>What You Can Do</strong></p>
                    <ul className="upskill-list" style={{ marginTop: '10px', marginLeft: '20px', listStyleType: 'disc' }}>
                        <li style={{ marginBottom: '8px' }}><strong>Identify Skill Gaps</strong> – Know what skills you need to improve</li>
                        <li style={{ marginBottom: '8px' }}><strong>Explore Roles</strong> – Discover career paths across the pharma industry</li>
                        <li style={{ marginBottom: '8px' }}><strong>Plan Progression</strong> – Create a roadmap for your professional growth</li>
                    </ul>
                </div>

                <div className="upskill-content-block" style={{ marginTop: '20px' }}>
                    <p className="upskill-description"><strong>What We Provide</strong></p>
                    <ul className="upskill-list" style={{ marginTop: '10px', marginLeft: '20px', listStyleType: 'disc' }}>
                        <li style={{ marginBottom: '8px' }}>Curated learning resources</li>
                        <li style={{ marginBottom: '8px' }}>Guidance for career development</li>
                        <li style={{ marginBottom: '8px' }}>Industry and regulatory updates</li>
                        <li style={{ marginBottom: '8px' }}>Soft skills and leadership support</li>
                    </ul>
                </div>

                <p className="upskill-growth-note" style={{ marginTop: '30px', fontWeight: 'bold' }}>
                    👉 Learn smarter, grow faster, and build a stronger pharma career.
                </p>
            </div>
        </section>
    );
};

export default UpskillResources;
